import Error from "./ErrorComponent";
export default Error;
